import React from 'react';

export interface SubtitleTracksProps {
    subtitleTracks: JSX.Element[] | null;
}

export default function SubtitleTracks(props: SubtitleTracksProps) {
    const {subtitleTracks} = props;
    return (
        <div>
            {subtitleTracks}
        </div>
    );
}
